/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class FormSettingDialog extends NoboxEntityDialog<FormRow, any> {
        protected getFormKey() { return FormSetting.formKey; }
        protected getIdProperty() { return FormRow.idProperty; }
        protected getLocalTextPrefix() { return FormRow.localTextPrefix; }
        protected getNameProperty() { return FormRow.nameProperty; }
        protected getService() { return FormService.baseUrl; }
        protected getDeletePermission() { return FormRow.deletePermission; }
        protected getInsertPermission() { return FormRow.insertPermission; }
        protected getUpdatePermission() { return FormRow.updatePermission; }

        protected form = new FormSetting(this.idPrefix);
        //protected lblElm = `<label class="caption"></label>`;
        protected checkElm = `<input type="checkbox" class="editor mr-1 checkField" name="Show" title="Show" DataCheck>`;
        protected inpElm = `<div class="form-control bgCustom col text-ellipsis"><span>DataValue</span>DataRequired</div>`;
        protected CategoryElm = `<div class="form-control col text-ellipsis"><div class="chat-sap mx-0 py-0" style="margin: 2px 0;"><div class="chat-sap-meta" style="display: table-row;"><span><b style="color:#344357;">DataCategory :&nbsp;</b></span></div></div></div>`;
        protected btnSettings = `<a class="btn inplace-button settingsField" title="Settings"><b><i class="fa fa-cog"></i></b></a>`;
        protected btnDelete = `<a class="btn inplace-button deleteField" title="Delete"><b><i class="fa fa-trash"></i></b></a>`;
        protected btnUp = `<a class="btn inplace-button upField disabled" title="Move to top"><b><i class="fa fa-chevron-up"></i></b></a>`;
        protected btnDown = `<a class="btn inplace-button downField disabled" title="Move to bottom"><b><i class="fa fa-chevron-down"></i></b></a>`;
        protected btnInfo = `<a class="btn inplace-button" tabindex="0" data-toggle="tooltip" title="This field will only appear if the form type is Order and the product field is filled in"><b><i class="fa fa-info"></i></b></a>`;
        protected data: Array<form>;
        protected dataPayments: Array<formPayment>;
        protected dataFollowUp: Array<followUp>;
        public isFormImport = false;
        public importCallback = (res: FormRow) => { }
        listFollowUp = [
            {
                "id": 9,
                "title": "Redirect",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻"
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻"
                    }
                ]
            },
            {
                "id": 1,
                "title": "Welcome",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "*Thank you, we have received your data with the following details*\n\n*Your Data:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "*Thank you, we have received your order with the following details*\n\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\nPlease Transfer to the Following Account: \n{bank_accounts}\n{order_id}\n\n*If you have transferred, please confirm so that we can process it immediately*"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "*Thank you, we have received your order with the following details*\n\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*Is the address complete and correct? Please confirm, sis, so that we can immediately process the package for delivery.*"
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "*Thank you, we have received your order with the following details*\n\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*To process your order, you can make the payment, OK, sis*, {e_payment_link}"
                    }
                ]
            },
            {
                "id": 2,
                "title": "Order Detail",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "*Your Data:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "*Your Order:*\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*Please transfer {grand_total}, to one of the accounts below:*\n{bank_accounts}"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "*Your Order:*\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*Sis, you can prepare {grand_total} and make sure the phone number and address are correct, sis*"
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "*Your Order:*\n{products}\n\n*Shipped to:*\nName: {customer_name}\nPhone Number: {customer_phone}\nAddress: {customer_address}\nCountry: {customer_country}\nProvince: {customer_state}\nCity: {customer_city}\n\n*To process your order, you can make the payment, OK, sis*, {e_payment_link}"
                    }
                ]
            },
            {
                "id": 3,
                "title": "Follow Up 1",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "Hello sis, for the items you ordered, we checked that payment has not been made yet.\nTo process your order, you can make the payment, bro 😊\n\nYou can make the payment to your account number:\n{bank_accounts}"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "Hello sis, please confirm whether the address is correct and complete for the COD package order? So that we can immediately send the package 😊 thank you."
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "Hello sis, for the items you ordered, we checked that payment has not been made yet.\nTo process your order, you can make the payment, bro 😊\n\nTo process your order, you can make the payment"
                    }
                ]
            },
            {
                "id": 4,
                "title": "Follow Up 2",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "Hello sis, good evening,\nTo process your order, you can make the payment, bro 😊\n\nYou can make the payment to your account number:\n{bank_accounts}"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "Hello sis, I want to confirm that the COD package order is ready to be shipped, please confirm, bro, is the address complete?"
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "Hello sis, good evening,\nTo process your order, you can make the payment, bro 😊\n\nTo process your order, you can make the payment"
                    }
                ]
            },
            {
                "id": 5,
                "title": "Follow Up 3",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "Hello sis, good evening,\nThe products you checked out have a few items left"
                    }
                ]
            },
            {
                "id": 6,
                "title": "Processing",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "We have received data from {customer_name}, and we are currently processing your data."
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "We have received payment from {customer_name} for the purchase of {products} totaling {total_price}, we are now processing your order. 😊\n\nYou can make the payment to your account number:\n{bank_accounts}"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "We have received an order from {customer_name} for the purchase of {products} totaling {total_price}, and we are currently processing your order."
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "We have received payment from {suctomer_name} for the purchase of {products} totaling {total_price}, we are now processing your order. 😊\n\nTo process your order, you can make the payment"
                    }
                ]
            },
            {
                "id": 7,
                "title": "Complete",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Thank you sis {customer_name} for filling out this form 🙏🏻, I appreciate you"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again"
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again"
                    }
                ]
            },
            {
                "id": 8,
                "title": "Up Selling",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Thank you sis {customer_name} for filling out this form 🙏🏻"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "Hello, we have a special promotion just for you {customer_name}\n\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\nLimited stock, order now before it runs out...️"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "Hello, we have a special promotion just for you {customer_name}\n\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\nLimited stock, order now before it runs out...️"
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "Hello, we have a special promotion just for you {customer_name}\n\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\nLimited stock, order now before it runs out...️"
                    }
                ]
            }
        ];


        array_move(old_index, new_index) {
            if (new_index >= this.data.length) {
                var k = new_index - this.data.length + 1;
                while (k--) {
                    this.data.push(undefined);
                }
            }
            this.data.splice(new_index, 0, this.data.splice(old_index, 1)[0]);
            return this.data; // for testing
        };

        array_movePay(old_index, new_index) {
            if (new_index >= this.dataPayments.length) {
                var k = new_index - this.dataPayments.length + 1;
                while (k--) {
                    this.dataPayments.push(undefined);
                }
            }
            this.dataPayments.splice(new_index, 0, this.dataPayments.splice(old_index, 1)[0]);
            return this.dataPayments; // for testing
        };

        renderHeader(param: string) {
            var data = { t: "", isT: false, d: "", isD: false };
            if (!Q.isEmptyOrNull(param)) {
                data = JSON.parse(param);
            }
            var rTitle = !data.isT ? "readonly" : null;
            var rDesc = !data.isD ? "readonly" : null;
            $(".checkHTitle").on("change", function () {
                let value = $(this).is(":checked");
                let inp = $(".inputHTitle");
                if (value) {
                    inp.removeClass("readonly");
                    inp.removeAttr("readonly");
                } else {
                    inp.addClass("readonly");
                    inp.attr("readonly", "true");
                }
            });
            $(".checkHDesc").on("change", function () {
                let value = $(this).is(":checked");
                let inp = $(".inputHDesc");
                if (value) {
                    inp.removeClass("readonly");
                    inp.removeAttr("readonly");
                } else {
                    inp.addClass("readonly");
                    inp.attr("readonly", "true");
                }
            })
        }

        renderPayment() {
            this.form.Payment.element.html("");
            this.form.Payment.element.addClass("row px-1");
            var $this = this;
            if (this.dataPayments.length > 0) {
                this.dataPayments.forEach((yz, ind) => {
                    let elm = `<div class="field ${yz.name} col-md-4 col-sm-12" data-index="${ind}">`;
                    elm += this.checkElm.replace("checkField", "checkFieldPay").replace("DataCheck", `${yz.isShow ? "checked" : ""} data-id="${yz.id}"`);
                    elm += this.inpElm.replace("DataValue", yz.name).replace("DataRequired", "");
                    //elm += this.btnInfo.replace(" and the product field is filled in", "");
                    elm += `</div>`;
                    this.form.Payment.element.append(elm);

                    $(".checkFieldPay").unbind("click");
                    $(".checkFieldPay").on("change", function () {
                        let i = $(this).parent().attr("data-index");
                        let valEPay = $(this).is(":checked");
                        $this.dataPayments[i].isShow = valEPay;
                    });
                })
            }
            NioApp.BS.tooltip('[data-toggle="tooltip"]');
        }

        renderOptSendMail(entity: FormRow) {
            var objSendMail = {
                accId: null,
                toIdExt: null
            } as optAkun;

            var accMail = this.form.accMail;
            var toMail = this.form.toMail;
            if (!Q.isEmptyOrNull(entity.DataMail))
                objSendMail = JSON.parse(entity.DataMail) as optAkun;

            if (objSendMail.accId != null)
                accMail.set_value(`${objSendMail.accId}`);

            toMail.value = objSendMail.toIdExt;
        }

        renderOptSendWa(entity: FormRow) {
            var objSendWa = {
                accId: null,
                toIdExt: null
            } as optAkun;

            var accWa = this.form.accWa;
            var toWa = this.form.toWa;
            if (!Q.isEmptyOrNull(entity.DataWa))
                objSendWa = JSON.parse(entity.DataWa) as optAkun;

            if (objSendWa.accId != null)
                accWa.set_value(`${objSendWa.accId}`);

            toWa.value = objSendWa.toIdExt;
        }

        renderSuccessMsg(param: string, type: FormTypeEnum) {
            var data = {
                h: "Thank you",
                data: {
                    bank: "Order via Bank Transfer",
                    cod: "Order via COD",
                    epay: "Order via E-Payment",
                    basic: "Thank's for filled form"
                }
            }
            if (!Q.isEmptyOrNull(param)) {
                data = JSON.parse(param);
                this.form.SuccessData.value = data.h;
            }
        }

        constructor() {
            super();
            var initFile = false;
            //this.form.Data.element.css("overflow-x", "hidden");
            this.form.Payment.element.css("overflow-x", "hidden");
            //this.form.Data.getGridField().css("overflow-x", "hidden");
            this.form.Payment.getGridField().css("overflow-x", "hidden");
            //this.form.Type.element.addClass("col-md-4 col-sm-12")
        }
        protected updateInterface() {

            super.updateInterface();

            if (this.isFormImport) {
                this.saveAndCloseButton.on("click", () => {
                    var item = this.getSaveEntity();
                    this.importCallback(item);
                })
                this.applyChangesButton.hide();
                this.deleteButton.hide()
            }
        }

        save(callback?: (response: Serenity.SaveResponse) => void) {
            if (this.isFormImport) {
                if (this.validateForm()) {
                    this.importCallback(this.getSaveEntity());
                    this.dialogClose();
                }
            } else {
                super.save(callback)
            }
        }

        getFollowUpData() {
            var $this = this;
            this.form.FollowUp.element.find("textarea.followupdata").each(function () {
                var data = $(this).data();
                let objFl = $this.listFollowUp.findIndex((yz) => yz.id == data.fl)
                if (objFl != -1) {
                    let objFlItem = $this.listFollowUp[objFl].data.findIndex((yz) => yz.id == data.dt)
                    if (objFlItem != -1)
                        $this.listFollowUp[objFl].data[objFlItem].text = $(this).val();
                }
            });
            return JSON.stringify(this.listFollowUp);
        }

        getSaveEntity() {
            var entity = super.getSaveEntity();
            entity.FollowUp = this.getFollowUpData();
            entity.Layout = $("input[name='layoutRadio']:checked").val();
            entity.HData = JSON.stringify({ t: $(".inputHTitle").val(), isT: $(".checkHTitle").is(":checked"), d: $(".inputHDesc").val(), isD: $(".checkHDesc").is(":checked") });
            entity.DataMail = JSON.stringify({ accId: this.form.accMail.get_value(), toIdExt: this.form.toMail.value } as optAkun);
            entity.DataWa = JSON.stringify({ accId: this.form.accWa.get_value(), toIdExt: this.form.toWa.value } as optAkun);
            entity.Payment = /*this.form.Type.get_value() == FormTypeEnum.Basic ? null :*/ JSON.stringify(this.dataPayments);
            if (this.dataFollowUp.length == 9) {
                let objFlUp = this.dataFollowUp.find(obj => obj.id == 9);
                if (objFlUp) {
                    entity.SuccessData = JSON.stringify({
                        h: this.form.SuccessData.value,
                        data: {
                            basic: objFlUp.data[0].text,
                            bank: objFlUp.data[1].text,
                            cod: objFlUp.data[2].text,
                            epay: objFlUp.data[3].text
                        }
                    })
                }
            }
            return entity;
        }
        loadEntity(entity: FormRow) {
            super.loadEntity(entity);
            var listPay = [
                {
                    id: 1,
                    name: "Bank Transfer",
                    isShow: true
                }, {
                    id: 2,
                    name: "COD",
                    isShow: false
                }, {
                    id: 3,
                    name: "E-Payment",
                    isShow: false,
                }
            ] as Array<formPayment>;
            if (this.isNew()) {
                this.form.Up.element.closest('.category').toggle(false);
                this.data = [
                    {
                        id: 1,
                        //name: "Name",
                        isShow: true,
                        settings: {
                            field: "input",
                            inputType: "text",
                            required: true,
                            label: "Name",
                            placeHolder: "Your Name",
                            selectOpsi: null
                        } as settingsForm,
                    }, {
                        id: 2,
                        //name: "Phone",
                        isShow: true,
                        settings: {
                            field: "input",
                            inputType: "number",
                            required: true,
                            label: "Phone",
                            placeHolder: "Phone/WhatsApp"
                        } as settingsForm,
                    }, {
                        id: 3,
                        //name: "Phone 112",
                        isShow: false,
                        settings: {
                            field: "input",
                            inputType: "email",
                            required: false,
                            label: "Email",
                            placeHolder: "Your Email"
                        } as settingsForm,
                    }, {
                        id: 9,
                        //name: "Phone 112",
                        isShow: true,
                        settings: {
                            field: "input",
                            inputType: "order",
                            required: true,
                            label: "Quantity",
                            placeHolder: "Quantity",
                            orderQuantity: "1,1,30"
                        } as settingsForm,
                    }, {
                        id: 4,
                        //name: "Phone 112",
                        isShow: false,
                        settings: {
                            field: "input",
                            inputType: "text",
                            required: false,
                            label: "Note",
                            placeHolder: "Note"
                        } as settingsForm,
                    }, {
                        id: 5,
                        //name: "Phone 112",
                        isShow: true,
                        settings: {
                            field: "textarea",
                            inputType: "",
                            required: true,
                            label: "Address",
                            placeHolder: "Address"
                        } as settingsForm,
                    }, {
                        id: 6,
                        //name: "Phone 112",
                        isShow: false,
                        settings: {
                            field: "select",
                            inputType: "",
                            required: true,
                            label: "Country",
                            placeHolder: "Your Country",
                            selectOpsi: []
                        } as settingsForm,
                    }, {
                        id: 7,
                        //name: "Phone 112",
                        isShow: false,
                        settings: {
                            field: "select",
                            inputType: "",
                            required: true,
                            label: "State",
                            placeHolder: "Your State",
                            selectOpsi: []
                        } as settingsForm,
                    }, {
                        id: 8,
                        //name: "Phone 112",
                        isShow: false,
                        settings: {
                            field: "select",
                            inputType: "",
                            required: true,
                            label: "City",
                            placeHolder: "Your City",
                            selectOpsi: []
                        } as settingsForm,
                    }
                ] as Array<form>;

                this.dataPayments = listPay;
                this.element.find(".generate-qrcode").hide();
                this.element.find(".preview-form").hide();
                this.element.find(".embed-form").hide();
            } else {
                this.form.Up.element.closest('.category').toggle(true);

                this.dataPayments = /*entity.Type == FormTypeEnum.Basic ? listPay :*/ Q.isEmptyOrNull(entity.Payment) || !this.isValidJSON(entity.Payment) ? listPay : JSON.parse(entity.Payment);
                this.element.find(".generate-qrcode").show();
                this.element.find(".preview-form").show();
                this.element.find(".embed-form").show();
            }

            this.renderOptSendWa(entity);
            this.renderOptSendMail(entity);
            this.renderHeader(entity.HData);
            //this.renderElm();
            this.renderPayment();
            this.renderSuccessMsg(entity.SuccessData, entity.Type);

            this.onChangeSuccessType(entity.SuccessType);
            this.form.SuccessType.change(() => {
                let val = this.form.SuccessType.get_value();
                this.onChangeSuccessType(val);
            });

            this.onChangeIsSendWa(entity.IsSendWa == 1 ? true : false);
            this.form.IsSendWa.change(() => {
                let val = this.form.IsSendWa.value;
                this.onChangeIsSendWa(val);
            })

            this.onChangeIsSendMail(entity.IsSendMail == 1 ? true : false);
            this.form.IsSendMail.change(() => {
                let val = this.form.IsSendMail.value;
                this.onChangeIsSendMail(val);
            })
            this.onChangeIsSendUrl(entity.IsSendURL == 1 ? true : false);
            this.form.IsSendURL.change(() => {
                let val = this.form.IsSendURL.value;
                this.onChangeIsSendUrl(val);
            })
            this.renderFollowUp(Q.isEmptyOrNull(entity.FollowUp) || !this.isValidJSON(entity.FollowUp) ? this.listFollowUp : JSON.parse(entity.FollowUp).length != 9 ? this.listFollowUp : JSON.parse(entity.FollowUp));
        }
        isValidJSON(jsonString) {
            try {
                JSON.parse(jsonString);
                return true;
            } catch (error) {
                return false;
            }
        }
        renderSubFollowUp(arrFollowUpItem, fl) {
            let elmChild = `<ul class="nav nav-tabs" id="followUpChildTab-${fl.id}" role="tablist" style="justify-content: start;">`;
            let elmChildContent = `<div class="tab-content" id="followUpChildTabContent-${fl.id}">`;
            arrFollowUpItem.map((dt, indDt) => {
                elmChild += `<li class="nav-item" role="presentation">
                                <button class="nav-link ${indDt == 0 ? "active" : ""}" id="child-${fl.id}-${dt.id}-tab" data-bs-toggle="tab" data-bs-target="#child-${fl.id}-${dt.id}-tab-pane"
                                    type="button" role="tab" aria-controls="child-${fl.id}-${dt.id}-tab-pane" aria-selected="${indDt == 0 ? "true" : ""}">${dt.title}</button>
                            </li>`
                elmChildContent += `<div class="tab-pane fade ${indDt == 0 ? "show active" : ""}" id="child-${fl.id}-${dt.id}-tab-pane" role="tabpanel" aria-labelledby="child-${fl.id}-${dt.id}-tab" tabindex="0">
                                            <input class="col-md-3 col-sm-12 mt-2 followupdataSelect p-0" data-textareaid="inp-child-${fl.id}-${dt.id}">
                                            <textarea class="mt-1 followupdata" rows="8" id="inp-child-${fl.id}-${dt.id}" data-fl="${fl.id}" data-dt="${dt.id}">${dt.text}</textarea>
                                        </div>`;
            })
            elmChild += "</ul>"
            elmChildContent += "</div>"

            var hasil = elmChild + elmChildContent;
            return hasil;
        }

        renderFollowUp(listFollowUp) {
            let ind = listFollowUp.findIndex(c => c.id == 9);
            if (ind == 8) {
                // Remove the last element from the array
                let lastElement = listFollowUp.pop();
                // Add the last element to the beginning of the array
                listFollowUp.unshift(lastElement);
            }

            this.dataFollowUp = listFollowUp;
            var $this = this;
            var elmInduk = this.form.FollowUp.element;
            elmInduk.html("");
            var elmTab = `<ul class="nav nav-tabs" id="followUpTab" role="tablist" style="justify-content: start;">`;
            var elmTabContent = `<div class="tab-content" id="followUpTabContent">`;
            listFollowUp.forEach((fl, ind) => {
                elmTab += `<li class="nav-item" role="presentation">
                                <button class="nav-link ${ind == 0 ? "active" : ""}" id="induk-${fl.id}-tab" data-bs-toggle="tab" data-bs-target="#induk-${fl.id}-tab-pane"
                                    type="button" role="tab" aria-controls="induk-${fl.id}-tab-pane" aria-selected="${ind == 0 ? "true" : ""}">${fl.title}</button>
                            </li>`;
                elmTabContent += `<div class="tab-pane fade pt-2 ${ind == 0 ? 'show active' : ''}" id="induk-${fl.id}-tab-pane" role="tabpanel" aria-labelledby="induk-${fl.id}-tab" tabindex="0">
                                    ${this.renderSubFollowUp(fl.data, fl)}
                                </div>`
            })
            elmTab += `</ul>`;
            elmTabContent += `</div>`;
            elmInduk.append(elmTab + elmTabContent)
            elmInduk.find("input.followupdataSelect").each(function () {
                let elmSelect = new FormFollowUpVariableEditor($(this));
                elmSelect.change((e) => {
                    let valSelect = elmSelect.get_value();
                    if (!Q.isEmptyOrNull(valSelect)) {
                        let idTextarea = $(this).attr("data-textareaid");
                        $this.setValueAtCursor($(`#${idTextarea}`), valSelect)
                        elmSelect.set_value(null);
                    }
                })
            })
        }

        setValueAtCursor(textarea, value) {
            // Get cursor position
            var cursorPos = textarea.prop("selectionStart");

            // Get current textarea value
            var currentText = textarea.val();

            // Set the new value at the cursor position
            var newText = currentText.slice(0, cursorPos) + value + currentText.slice(cursorPos);

            // Update textarea value
            textarea.val(newText);

            // Move the cursor to the end of the inserted text
            textarea.prop("selectionStart", cursorPos);
            textarea.prop("selectionEnd", cursorPos + value.length);

            textarea.focus();
        }


        dialogClose() {

        }

        updateTitle() {
            this.dialogTitle = "Form Settings";
        }

        dialogOpen() {
            super.dialogOpen();

            this.element.children("div.panel-titlebar").find("button.panel-titlebar-close").remove();
            this.element.children("div.panel-titlebar").css("justify-content", "space-between");
            this.element.children("div.panel-titlebar").append(`<a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm p-0 ml-1 float-right" target="_blank" href="${$('#GridDiv').attr('help-url')}">
                    <div class="tool-button icon-tool-button" title="Help">
                        <div class="button-outer">
                            <span class="button-inner green">
                                <i class="fa fa-question-circle text-blue"></i>
                            </span>
                        </div>
                    </div>
                </a>`);
            Q.Router.replace("");
        }
        onChangeIsSendWa(val: boolean) {
            if (!val) {
                this.form.accWa.set_readOnly(true);
                Serenity.EditorUtils.setReadonly(this.form.toWa.element, true);
                Serenity.EditorUtils.setRequired(this.form.toWa, false);
                Serenity.EditorUtils.setRequired(this.form.accWa, false);
            } else {
                this.form.accWa.set_readOnly(false);
                Serenity.EditorUtils.setReadonly(this.form.toWa.element, false);
                Serenity.EditorUtils.setRequired(this.form.toWa, true);
                Serenity.EditorUtils.setRequired(this.form.accWa, true);
            }
        }
        onChangeIsSendUrl(val: boolean) {
            if (!val) {
                Serenity.EditorUtils.setReadonly(this.form.DataSendURL.element, true);
                Serenity.EditorUtils.setRequired(this.form.DataSendURL, false);
            } else {
                Serenity.EditorUtils.setReadonly(this.form.DataSendURL.element, false);
                Serenity.EditorUtils.setRequired(this.form.DataSendURL, true);
            }
        }
        onChangeIsSendMail(val: boolean) {
            if (!val) {
                this.form.accMail.set_readOnly(true);
                Serenity.EditorUtils.setReadonly(this.form.toMail.element, true);
                Serenity.EditorUtils.setRequired(this.form.toMail, false);
                Serenity.EditorUtils.setRequired(this.form.accMail, false);
            } else {
                this.form.accMail.set_readOnly(false);
                Serenity.EditorUtils.setReadonly(this.form.toMail.element, false);
                Serenity.EditorUtils.setRequired(this.form.toMail, true);
                Serenity.EditorUtils.setRequired(this.form.accMail, true);
            }
        }
        onChangeSuccessType(val: FormSuccessTypeEnum) {
            let fldSuccess = this.form.SuccessData.getGridField();
            //this.form.SuccessData.value = null;
            if (val == FormSuccessTypeEnum.Page) {
                //this.form.SuccessDataContainer.getGridField().toggle(true);
                fldSuccess.children("label").html("<sup title='this field is required'>*</sup>Headline");
                fldSuccess.children("input").attr("placeholder", "ex: Thank's for your order");
            } else if (val == FormSuccessTypeEnum.Url) {
                //this.form.SuccessDataContainer.getGridField().toggle(false);
                fldSuccess.children("label").html("<sup title='this field is required'>*</sup>URL");
                fldSuccess.children("input").attr("placeholder", "ex: https://id.nobox.ai/");
            } else if (val == FormSuccessTypeEnum.Wa) {
                //this.form.SuccessDataContainer.getGridField().toggle(false);
                fldSuccess.children("label").html("<sup title='this field is required'>*</sup>Wa Number");
                fldSuccess.children("input").attr("placeholder", "ex: 62...");
            }
        }

        protected getToolbarButtons() {
            var btn = super.getToolbarButtons();
            var $this = this;
            btn[2].visible = false;
            btn[0].visible = false;
            btn[1].title = "Save";
            btn[1].icon = "fa fa-check-circle text-purple";

            btn.push({
                icon: "fa fa-undo-alt text-primary",
                separator: true,
                title: "Reset",
                onClick: () => {
                    var dataDefault = {
                        Name: `Setting Form`,
                        ProductId: null,
                        Data: null,
                        Type: 2,
                        SuccessType: 1,
                        SuccessData: `{\"h\":\"Thank you\",\"data\":{\"basic\":\"Thank you sis {customer_name} for filled this form 🙏🏻\",\"bank\":\"Hello, I have placed an order for {product_name}, under the name {customer_name}. Please process it immediately. 🙏🏻\",\"cod\":\"Hello, I have placed an order for {product_name}, under the name {customer_name}. Please process it immediately. 🙏🏻\",\"epay\":\"Hello, I have placed an order for {product_name}, under the name {customer_name}. Please process it immediately. 🙏🏻\"}}`,
                        FollowUp: `[{\"id\":1,\"title\":\"Welcome\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"*Thank you, we have received your data with the following details*\\n\\n*Your Data:*\\nName: {customer_name}\\nPhone Number: {customer_phone}\\nAddress: {customer_address}\\nCountry: {customer_country}\\nProvince: {customer_state}\\nCity: {customer_city}\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"*Thank you, we have received your order with the following details*\\n\\n{products}\\n\\n*Shipped to:*\\nName: {customer_name}\\nPhone Number: {customer_phone}\\nAddress: {customer_address}\\nCountry: {customer_country}\\nProvince: {customer_state}\\nCity: {customer_city}\\n\\nPlease Transfer to the Following Account: \\n{bank_accounts}\\n{order_id}\\n\\n*If you have transferred, please confirm so that we can process it immediately*\"},{\"id\":3,\"title\":\"COD\",\"text\":\"*Thank you, we have received your order with the following details*\\n\\n{products}\\n\\n*Shipped to:*\\nName: {customer_name}\\nPhone Number: {customer_phone}\\nAddress: {customer_address}\\nCountry: {customer_country}\\nProvince: {customer_state}\\nCity: {customer_city}\\n\\n*Is the address complete and correct? Please confirm, sis, so that we can immediately process the package for delivery.*\"},{\"id\":4,\"title\":\"E-Payment\",\"text\":\"*Thank you, we have received your order with the following details*\\n\\n{products}\\n\\n*Shipped to:*\\nName: {customer_name}\\nPhone Number: {customer_phone}\\nAddress: {customer_address}\\nCountry: {customer_country}\\nProvince: {customer_state}\\nCity: {customer_city}\\n\\n*To process your order, you can make the payment, OK, sis*, {e_payment_link}\"}]},{\"id\":2,\"title\":\"Order Detail\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"*Your Data:*\\nName: {customer_name}\\nPhone Number: {customer_phone}\\nAddress: {customer_address}\\nCountry: {customer_country}\\nProvince: {customer_state}\\nCity: {customer_city}\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"*Your Order:*\\n{products}\\n\\n*Shipped to:*\\nName: {customer_name}\\nPhone Number: {customer_phone}\\nAddress: {customer_address}\\nCountry: {customer_country}\\nProvince: {customer_state}\\nCity: {customer_city}\\n\\n*Please transfer {grand_total}, to one of the accounts below:*\\n{bank_accounts}\"},{\"id\":3,\"title\":\"COD\",\"text\":\"*Your Order:*\\n{products}\\n\\n*Shipped to:*\\nName: {customer_name}\\nPhone Number: {customer_phone}\\nAddress: {customer_address}\\nCountry: {customer_country}\\nProvince: {customer_state}\\nCity: {customer_city}\\n\\n*Sis, you can prepare {grand_total} and make sure the phone number and address are correct, sis*\"},{\"id\":4,\"title\":\"E-Payment\",\"text\":\"*Your Order:*\\n{products}\\n\\n*Shipped to:*\\nName: {customer_name}\\nPhone Number: {customer_phone}\\nAddress: {customer_address}\\nCountry: {customer_country}\\nProvince: {customer_state}\\nCity: {customer_city}\\n\\n*To process your order, you can make the payment, OK, sis*, {e_payment_link}\"}]},{\"id\":3,\"title\":\"Follow Up 1\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"Thank you sis {customer_name} for filling out this form 🙏🏻\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"Hello sis, for the items you ordered, we checked that payment has not been made yet.\\nTo process your order, you can make the payment, bro 😊\\n\\nYou can make the payment to your account number:\\n{bank_accounts}\"},{\"id\":3,\"title\":\"COD\",\"text\":\"Hello sis, please confirm whether the address is correct and complete for the COD package order? So that we can immediately send the package 😊 thank you.\"},{\"id\":4,\"title\":\"E-Payment\",\"text\":\"Hello sis, for the items you ordered, we checked that payment has not been made yet.\\nTo process your order, you can make the payment, bro 😊\\n\\nTo process your order, you can make the payment\"}]},{\"id\":4,\"title\":\"Follow Up 2\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"Thank you sis {customer_name} for filling out this form 🙏🏻\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"Hello sis, good evening,\\nTo process your order, you can make the payment, bro 😊\\n\\nYou can make the payment to your account number:\\n{bank_accounts}\"},{\"id\":3,\"title\":\"COD\",\"text\":\"Hello sis, I want to confirm that the COD package order is ready to be shipped, please confirm, bro, is the address complete?\"},{\"id\":4,\"title\":\"E-Payment\",\"text\":\"Hello sis, good evening,\\nTo process your order, you can make the payment, bro 😊\\n\\nTo process your order, you can make the payment\"}]},{\"id\":5,\"title\":\"Follow Up 3\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"Thank you sis {customer_name} for filling out this form 🙏🏻\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"Hello sis, good evening,\\nThe products you checked out have a few items left\"}]},{\"id\":6,\"title\":\"Processing\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"We have received data from {customer_name}, and we are currently processing your data.\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"We have received payment from {customer_name} for the purchase of {products} totaling {total_price}, we are now processing your order. 😊\\n\\nYou can make the payment to your account number:\\n{bank_accounts}\"},{\"id\":3,\"title\":\"COD\",\"text\":\"We have received an order from {customer_name} for the purchase of {products} totaling {total_price}, and we are currently processing your order.\"},{\"id\":4,\"title\":\"E-Payment\",\"text\":\"We have received payment from {suctomer_name} for the purchase of {products} totaling {total_price}, we are now processing your order. 😊\\n\\nTo process your order, you can make the payment\"}]},{\"id\":7,\"title\":\"Complete\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"Thank you sis {customer_name} for filling out this form 🙏🏻, I appreciate you\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again\"},{\"id\":3,\"title\":\"COD\",\"text\":\"Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again\"},{\"id\":4,\"title\":\"E-Payment\",\"text\":\"Thank you sis {customer_name} for shopping at our store 🙏🏻, may the items last long and you will visit our store again\"}]},{\"id\":8,\"title\":\"Up Selling\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"Thank you sis {customer_name} for filling out this form 🙏🏻\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"Hello, we have a special promotion just for you {customer_name}\\n\\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\\nLimited stock, order now before it runs out...️\"},{\"id\":3,\"title\":\"COD\",\"text\":\"Hello, we have a special promotion just for you {customer_name}\\n\\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\\nLimited stock, order now before it runs out...️\"},{\"id\":4,\"title\":\"E-Payment\",\"text\":\"Hello, we have a special promotion just for you {customer_name}\\n\\n- Product XYZ, from IDR 180,000 to only IDR 140,000 ☺\\nLimited stock, order now before it runs out...️\"}]},{\"id\":9,\"title\":\"Redirect\",\"data\":[{\"id\":1,\"title\":\"Basic\",\"text\":\"Thank you sis {customer_name} for filling out this form 🙏🏻\"},{\"id\":2,\"title\":\"Bank Transfer\",\"text\":\"Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻\"},{\"id\":3,\"title\":\"COD\",\"text\":\"Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻\"},{\"id\":4,\"title\":\"E-Payment\",\"text\":\"Hello, I have placed an order for {products}, on behalf of {customer_name}. Please process it soon. 🙏🏻\"}]}]`,
                        TagIds: null,
                        Payment: `[{\"id\":1,\"name\":\"Bank Transfer\",\"isShow\":true},{\"id\":2,\"name\":\"COD\",\"isShow\":false},{\"id\":3,\"name\":\"E-Payment\",\"isShow\":false}]`,
                        ShowLabel: 1,
                        ShowCoupon: 0,
                        ShowCaptcha: 1,
                        IsSendWa: 0,
                        IsSendMail: 0,
                        IsSendURL: 0,
                        DataWa: `{\"accId\":\"\",\"toIdExt\":\"\"}`,
                        DataMail: `{\"accId\":\"\",\"toIdExt\":\"\"}`,
                        DataSendURL: null,
                        Layout: 1,
                        HLogo: null,
                        HData: `{\"isT\":false,\"isD\":false}`,
                        BData: `{\"bg\":\"1\",\"txt\":\"Order now\"}`
                    } as FormRow;
                    Q.confirm("Are you sure to reset to default Form Setting?", async() => {
                        if (Q.isEmptyOrNull(document.documentElement.lang)) {

                        } else {
                            await Master.SettingPerLanguageService.List({
                                EqualityFilter: {
                                    Language: document.documentElement.lang,
                                    Type: "FormSetting"
                                }
                            }, (res) => {
                                if (res.Entities.length != 0) {
                                    var item = res.Entities[0];
                                    if (!Q.isEmptyOrNull(item.Setting)) {
                                        dataDefault = JSON.parse(item.Setting);

                                    }
                                }
                                Q.serviceCall({
                                    url: `/services/${FormService.baseUrl}/Update`,
                                    blockUI: true,
                                    request: {
                                        EntityId: 0,
                                        Entity: dataDefault
                                    } as Serenity.SaveRequest<FormRow>,
                                    onSuccess: (res: Serenity.SaveResponse) => {
                                        Q.notifySuccess(`Reset to default successfully`);
                                        dataDefault.Id = 0;
                                        this.loadEntity(dataDefault);
                                    }
                                })
                            })
                        }
                    });
                }
            })
            return btn;
        }
    }

    export interface optAkun {
        accId: number;
        toIdExt: string;
    }

    export interface selectOpsi {
        id: string;
        name: string;
        selected: boolean;
    }
    export interface settingsForm {
        field: string;
        inputType: string;
        selectOpsi: Array<selectOpsi>;
        required: boolean;
        label: string;
        placeHolder: string;
        orderQuantity: string;
    }
    export interface form {
        id: number;
        value: string;
        settings: settingsForm;
        isShow: boolean;
    }
    export interface formPayment {
        id: number;
        isShow: boolean;
        name: string;
        data: Array<opsiPayment>;
    }
    export interface opsiPayment {
        id: number;
        name: string;
        img: string;
        isShow: boolean;
    }
}
